import React from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const MainLayout = ({ children, user, userData }) => {
    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            background: 'var(--bg-secondary)',
            overflow: 'hidden'
        }}>
            <Navbar user={user} userData={userData} />
            <div className="container-fluid" style={{
                display: 'flex',
                gap: 'var(--spacing-md)',
                flex: 1,
                minHeight: 0,
                paddingBottom: 'var(--spacing-md)',
                transition: 'background 0.3s ease'
            }}>
                <Sidebar userData={userData} />
                <main style={{
                    flex: 1,
                    minWidth: 0,
                    overflowY: 'auto',
                    paddingRight: 'var(--spacing-md)',
                    height: '100%'
                }}>
                    {children}
                </main>
            </div>
        </div>
    );
};

export default MainLayout;
